<script>
    import { createEventDispatcher, onMount } from "svelte";
    import {
        availableProfiles,
        colorPalette
    } from "../../../stores/profile.js";
    import windows from "../../../stores/windows.js";

    const dispatch = createEventDispatcher();

    let indexForSelectedProfile = 0;
    let color = randomColor();

    onMount(() => {
        dispatch("change", {
            profile: {
                ...availableProfiles[indexForSelectedProfile],
                color
            }
        });
    });

    function randomColor() {
        return colorPalette[Math.trunc(colorPalette.length * Math.random())];
    }

    function didSubmitForm(e) {
        e.preventDefault();
    }

    function dispatchProfileChangeEvent() {
        dispatch("change", {
            profile: {
                ...availableProfiles[indexForSelectedProfile],
                color
            }
        });
    }

    function didSelectVehicleOption(e) {
        indexForSelectedProfile = parseInt(e.target.value);
        color = randomColor();
        dispatchProfileChangeEvent();
    }

    function didClickColorPickerButton() {
        const existing = $windows.find(
            (window) => window.kind === "color" && !window.isClosed
        );

        if (existing) {
            windows.focus(existing.id);
        } else {
            windows.focus(
                windows.open("color", {
                    onSelect(e) {
                        color = e.detail.color;
                        dispatchProfileChangeEvent();
                    }
                })
            );
        }
    }
</script>

<form on:submit={didSubmitForm}>
    {#each availableProfiles as profile, index}
        <div class="option">
            <input
                type="radio"
                name="vehicle"
                id={`vehicle-${index}`}
                value={index}
                checked={indexForSelectedProfile === index}
                on:change={didSelectVehicleOption}
            />
            <label for={`vehicle-${index}`}>
                <h2>{profile.displayName}</h2>
                <p>{profile.description}</p>
            </label>
            <button
                class="color"
                class:disabled={indexForSelectedProfile !== index}
                style={`background: ${color}`}
                on:click={didClickColorPickerButton}
            />
        </div>
    {/each}
</form>

<style>
    form {
        display: flex;
        flex-direction: column;
        gap: 1em;
        margin-top: 18px;
    }

    .option {
        display: flex;
        gap: 0.5em;
    }

    form input {
        display: block;
        position: relative;
        top: -4px;
        appearance: none;
        border-top: var(--border-color-dark) var(--chrome-depth) inset;
        border-right: var(--border-color-light) var(--chrome-depth) inset;
        border-bottom: var(--border-color-light) var(--chrome-depth) inset;
        border-left: var(--border-color-dark) var(--chrome-depth) inset;
        border-radius: 8px;
        background: white;
        width: 16px;
        height: 16px;
    }

    @media only screen and (max-width: 734px) {
        form input {
            height: 15px;
        }
    }

    form input:checked {
        color: black;
    }

    form input:before {
        position: relative;
        top: -7.5px;
        left: 1px;
        opacity: 0;
        content: "●";
        font-size: 19px;
    }

    @media only screen and (max-width: 734px) {
        form input:before {
            top: -9px;
            left: 0;
        }
    }

    form input:checked:before {
        opacity: 1;
    }

    label {
        flex-grow: 1;
    }

    h2,
    p {
        margin: 0;
        padding: 0;
    }

    .color {
        border-top: var(--border-color-dark) var(--chrome-depth) inset;
        border-right: var(--border-color-light) var(--chrome-depth) inset;
        border-bottom: var(--border-color-light) var(--chrome-depth) inset;
        border-left: var(--border-color-dark) var(--chrome-depth) inset;
        width: 22px;
        height: 22px;
    }

    .color.disabled {
        opacity: 0;
        pointer-events: none;
    }
</style>
